import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import classNames from "classnames/bind";
import { Container, Row, Col, Button, Jumbotron } from "reactstrap";
import { getCookie } from "~/utils/cookie";
import assetPath from "~/utils/assetPath";
import NavigationComponent from "~/components/NavigationComponent";
import FooterComponent from "~/components/FooterComponent";
import LinkComponent from "~/components/LinkComponent";
import { mailTo } from "~/utils/misc";

import styles from "./styles.scss";

class AboutComponent extends React.Component {
  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    // Configure download section buttons
    $("#about_component #download .button_container.mac").addClass(
      classNames({ active: is.truthy(bowser.mac) })
    );
    $("#about_component #download .download.mac")
      .addClass(classNames({ "btn-primary": is.truthy(bowser.mac) }))
      .removeClass(classNames({ "btn-secondary": is.truthy(bowser.mac) }));
    $("#about_component #download .button_container.windows").addClass(
      classNames({ active: is.truthy(bowser.windows) })
    );
    $("#about_component #download .download.windows")
      .addClass(classNames({ "btn-primary": is.truthy(bowser.windows) }))
      .removeClass(classNames({ "btn-secondary": is.truthy(bowser.windows) }));
    $("#about_component #download .button_container.linux").addClass(
      classNames({ active: is.truthy(bowser.linux) })
    );
    $("#about_component #download .download.linux")
      .addClass(classNames({ "btn-primary": is.truthy(bowser.linux) }))
      .removeClass(classNames({ "btn-secondary": is.truthy(bowser.linux) }));
    $("#about_component #download .button_container.android").addClass(
      classNames({ active: is.truthy(bowser.android) })
    );
    $("#about_component #download .download.android")
      .addClass(classNames({ "btn-primary": is.truthy(bowser.android) }))
      .removeClass(classNames({ "btn-secondary": is.truthy(bowser.android) }));
    $("#about_component #download .button_container.ios").addClass(
      classNames({ active: is.truthy(bowser.ios) })
    );
    $("#about_component #download .download.ios")
      .addClass(classNames({ "btn-primary": is.truthy(bowser.ios) }))
      .removeClass(classNames({ "btn-secondary": is.truthy(bowser.ios) }));

    // Configure game section buttons
    $("#about_component #games .button_container.mac").addClass(
      classNames({ hidden: is.not.truthy(bowser.mac) })
    );
    $("#about_component #games .button_container.windows").addClass(
      classNames({ hidden: is.not.truthy(bowser.windows) })
    );
    $("#about_component #games .button_container.linux").addClass(
      classNames({ hidden: is.not.truthy(bowser.linux) })
    );
    $("#about_component #games .button_container.android").addClass(
      classNames({ hidden: is.not.truthy(bowser.android) })
    );
    $("#about_component #games .button_container.ios").addClass(
      classNames({ hidden: is.not.truthy(bowser.ios) })
    );

    // Show notification on download click
    $(".download.linux, .download.android, .download.ios").on(
      "click",
      event => {
        // Show notification
        $.notify("Download coming soon.");

        // Track event
        mixpanel.track("Download tapped", {
          download_platform: $(event.target).data("platform")
        });
      }
    );

    // Setup share buttons
    $(".social_buttons").ayoshare({
      counter: false,
      button: {
        google: true,
        facebook: true,
        pinterest: true,
        twitter: true,
        email: true
      }
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="about_component">
        <Container id="navigation">
          <Row>
            <Col>
              <NavigationComponent />
            </Col>
          </Row>
        </Container>

        <Container id="introduction">
          <Row>
            <Col>
              <div>
                <h1>Jigsaw Puzzle: Play free online jigsaw puzzles games</h1>
              </div>
              <div>
                <p className="text_section">
                  Play Jigsaw Puzzle online for free. Enjoy a stylish & modern
                  version of timeless game. Play the game online or{" "}
                  <a href="#download">download</a> for Mac™, Windows™, iOS, Linux™ or Android.
                  <br />
                </p>
                <p className="text_section">
                  We've created a gameplay with with beautiful
                  graphics and easy gameplay, that you'll instantly love. Laying puzzles have never been so enjoyable.
                  <br />
                </p>
                <p className="text_section">
                  Jigsaw puzzle comes crammed  with features. Shuffle the pieces, show a preview, toggle borders, toggle the sound, hide the time and much more under settings.
                  <br />
                </p>
                <p className="text_section">
                  If it's your firs time playing puzzles online or you're unsure about the rules, please read the{" "}<a href="#rules">rules</a>. If you’re still not sure whether this jigsaw game is for you, have a look at the{" "}<a href="#features">features</a> it has or see how it{" "} <a href="#compare">compares</a> to other online jigsaw puzzle games.
                  <br />
                </p>
                <p className="text_section">
                  It's our hope that you'll like this free online jigsaw puzzle game. If you do, please have a look at all the different puzzles you can <a href="/spider">play</a> for free in this game.
                  <br />
                </p>
                <div
                  className="social_buttons"
                  data-ayoshare="https://online-jigsaw-puzzles.com"
                />
              </div>
            </Col>
          </Row>
        </Container>

        <Jumbotron fluid>
          <Container id="download">
            <Row>
              <Col>
                <div>
                  <h2>Free download of Jigsaw Puzzle</h2>
                </div>
                <div>
                  <p>
                    Download this classic jigsaw puzzle game to your Windows™,
                    Mac™, Linux™, Android or iOS. Always have the game on hand
                    and download the jigsaw game below.
                    <br />
                  </p>
                </div>
              </Col>
              <div className="button_outer_container">
                <Col className="button_container mac">
                  <Button
                    color="secondary download mac"
                    data-game="Jigsaw Puzzle"
                    data-platform="Mac"
                    tag={LinkComponent}
                    to="https://itunes.apple.com/us/app/id1436430887?ls=1&mt=12"
                    rel="nofollow"
                  >
                    Download for Mac™
                  </Button>
                </Col>
                <Col className="button_container windows">
                  <Button
                    color="secondary download windows"
                    data-game="Jigsaw Puzzle"
                    data-platform="Windows"
                    tag={LinkComponent}
                    to="https://www.microsoft.com/store/apps/9p33r1js35qp"
                    rel="nofollow"
                  >
                    Download for Windows™
                  </Button>
                </Col>
                <Col className="button_container linux">
                  <Button
                    color="secondary download linux"
                    data-game="Jigsaw Puzzle"
                    data-platform="Linux"
                  >
                    Download for Linux™
                  </Button>
                </Col>
                <Col className="button_container android">
                  <Button
                    color="secondary download android"
                    data-game="Jigsaw Puzzle"
                    data-platform="Android"
                  >
                    Download for Android
                  </Button>
                </Col>
                <Col className="button_container ios">
                  <Button
                    color="secondary download ios"
                    data-game="Jigsaw Puzzle"
                    data-platform="iOS"
                  >
                    Download for iOS
                  </Button>
                </Col>
              </div>
            </Row>
          </Container>
        </Jumbotron>

        <Container id="rules">
          <Row>
            <Col>
              <div>
                <h2>Jigsaw rules and guidelines: This is how you lay a jigsaw puzzle</h2>
              </div>
              <div>
                <h3 className="text_section">How to start a game:</h3>
                <p>
                  It's really all very simply. Click a collection from the main screen and then choose a puzzle to play from that collection. There are thousands of collections and even more puzzles, so there's many puzzles to choose from. Once you've done that, set the amount of pieces you want in that puzzle and then click "Start Puzzle". That will begin the puzzle.
                  <br />
                </p>
                <h3 className="text_section">Laying the puzzle:</h3>
                <p>
                  Once you've started the puzzle, the pieces will be laid out all over the screen. You can now move the pieces around. Click and drag to move the pieces and right click a piece to rotate it. If two pieces fit together, they will "click" together and make a little sound. Once all the pieces are together and you've solved the puzzle and congratulations screen will be shown.
                  <br />
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <Jumbotron fluid>
          <Container className="reviews">
            <Row>
              <Col className="review">
                <img
                  className="lazyload"
                  width="249"
                  height="38"
                  alt="Jigsaw online review"
                  data-src={assetPath("frontpage_stars", "png")}
                />
                <h4>
                  The greatest puzzle game I’ve played online. It also works great on tablet and mobile!
                </h4>
                <p>Arnold Patton</p>
              </Col>
              <Col className="review">
                <img
                  className="lazyload"
                  width="249"
                  height="38"
                  alt="Jigsaw online rating"
                  data-src={assetPath("frontpage_stars", "png")}
                />
                <h4>
                  It really is the greatest jigsaw game! A game that's worth playing.
                </h4>
                <p>Mary Christiansen</p>
              </Col>
            </Row>
          </Container>
        </Jumbotron>

        <Container id="features">
          <Row>
            <Col>
              <div>
                <h2>Features: This puzzle game is packed with features</h2>
              </div>
              <div>
                <p className="text_section">
                  You won't be able to find any other online jigsaw puzzles that are so ruch in features and Online Jigsaw Puzzle. Toggle the sound, show and hide edges, toggle the sound and much more under settings. If you want to play offline, you can always <a href="#download">download the app</a>.
                  <br />
                </p>
              </div>
            </Col>
          </Row>
          <Row className="feature_container">
            <Col className="feature">
              <img
                className="lazyload"
                width="88"
                height="88"
                alt="Unlimited free game plays"
                data-src={assetPath("frontpage_infinite", "png")}
              />
              <h4>Free and unlimited gameplays</h4>
              <p>
                Get free unlimited gameplays in both the offline and the
                online version of this jigsaw game.
              </p>
            </Col>
            <Col className="feature">
              <img
                className="lazyload"
                width="88"
                height="88"
                alt="Won"
                data-src={assetPath("frontpage_hint", "png")}
              />
              <h4>Congrantulations when won</h4>
              <p>
                When you've won, you'll be shown a nice congratulations screen.
              </p>
            </Col>
          </Row>
          <Row className="feature_container">
            <Col className="feature">
              <img
                className="lazyload"
                width="88"
                height="88"
                alt="iOS and iPad ready"
                data-src={assetPath("frontpage_sizes", "png")}
              />
              <h4>Mobile friendly</h4>
              <p>
                Our game is optimized for all screens and sizes. From the smallest mobile to the biggest desktop.
              </p>
            </Col>
            <Col className="feature">
              <img
                className="lazyload"
                width="88"
                height="88"
                alt="Beautiful design"
                data-src={assetPath("frontpage_design", "png")}
              />
              <h4>Beautiful design</h4>
              <p>
                Enjoy these classic games in a beautiful design, with
                custom-made cards for mobile and desktop.
              </p>
            </Col>
          </Row>
          <Row className="feature_container">
            <Col className="feature">
              <img
                className="lazyload"
                width="88"
                height="88"
                alt="Ready for retina"
                data-src={assetPath("frontpage_eye", "png")}
              />
              <h4>We're ready for retine</h4>
              <p>
                All our puzzles are optimized for the retina screen. So when you're playing on iOS, your MacBook or other retina screens, everything will be looking crystal clear.
              </p>
            </Col>
            <Col className="feature">
              <img
                className="lazyload"
                width="88"
                height="88"
                alt="Lots of settings"
                data-src={assetPath("frontpage_settings", "png")}
              />
              <h4>Great settings</h4>
              <p>
                You'll have great control over settings in this game. Control in game settings and global settings from the top menu.
              </p>
            </Col>
          </Row>
        </Container>

        <Container id="compare">
          <Row>
            <Col>
              <div>
                <h2>Compare: A comparison of online jigsaw puzzle games</h2>
              </div>
              <div>
                <p className="text_section">
                  We think we’ve made the greatest jigsaw puzzle game out there. Below you'll find a table, where you can see how this game compares to other jigsaw puzzle games. If you think this game is missing a
                  feature that one of the other jigsaw games has, please{" "}
                  <a href="#" onClick={mailTo}>
                    write us
                  </a>.
                  <br />
                </p>
                <p className="text_section">
                  Ever wondered if our puzzle game is better than Jigsaw Explorer or Jigzone? Now you can find out. Some of the more popular puzzle games out there are Jigsaw Planet, Free Jigsaw Puzzles and MSN free games, but even those don't stand a chance against this puzzle game.
                  <br />
                </p>
                <div className="table_container">
                  <table>
                    <tbody>
                      <tr>
                        <td />
                        <td>Modern design</td>
                        <td>Download available</td>
                        <td>Lots of options</td>
                        <td>Mobile friendly</td>
                        <td>Tablet friendly</td>
                      </tr>
                      <tr>
                        <td>Online Jigsaw Puzzle</td>
                        <td className="yes">Yes</td>
                        <td className="yes">Yes</td>
                        <td className="yes">Yes</td>
                        <td className="yes">Yes</td>
                        <td className="yes">Yes</td>
                      </tr>
                      <tr>
                        <td>Jigsaw Explorer</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>Free Jigsaw Puzzles</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>Jigzone</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>Jigsaw Planet</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>Buffalo Games</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>Jigsaw Puzzles Online</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>AARP Games</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>500 Piece Jigsaw Puzzles</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>Daily Jigsaw Puzzle</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>MSN Games</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                      <tr>
                        <td>MobilityWare</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                        <td className="no">No</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Jumbotron fluid>
          <Container className="reviews">
            <Row>
              <Col className="review">
                <img
                  className="lazyload"
                  width="249"
                  height="38"
                  alt="Review"
                  data-src={assetPath("frontpage_stars", "png")}
                />
                <h4>
                  I finally  have version of jigsaw game that works great on all
                  sizes and devices.
                </h4>
                <p>Henrik Martinsen</p>
              </Col>
              <Col className="review">
                <img
                  className="lazyload"
                  width="249"
                  height="38"
                  alt="Review"
                  data-src={assetPath("frontpage_stars", "png")}
                />
                <h4>
                  Filled with options and the game has a great gameplay. The game really has it all and it’s free!
                </h4>
                <p>Henrietta Nielsen</p>
              </Col>
            </Row>
          </Container>
        </Jumbotron>

        <Container id="games">
          <Row>
            <Col>
              <div>
                <h2>
                  Jigsaw games: Have a go at one of our other free online
                  puzzle games
                </h2>
              </div>
              <div>
                <p className="text_section">
                  Are you ready to try a different puzzle game? Choose between many puzzle games and play a game with 10 pieces, 500 pieces or even 1000  pieces. If you're missing a featyre that we haven’t made yet, please{" "}
                  <a href="#" onClick={mailTo}>
                    write us
                  </a>.
                  <br />
                </p>
              </div>
              <div className="game jigsaw">
                <Col className="icon_col">
                  <img
                    width="160"
                    height="160"
                    className="icon lazyload"
                    alt="Jigsaw game icon"
                    data-src={assetPath("frontpage_icon", "png")}
                  />
                </Col>
                <Col>
                  <h3>Jigsaw Puzzle</h3>
                  <p>
                    This is one of the most popular versions of jigsaw online. You can choose between thousands of different puzzles to play from and you can play puzzle game with more than 1000 pieces.
                  </p>
                </Col>
                <Col className="button_container">
                  <Button color="primary" tag={LinkComponent} to="/">
                    Play online now
                  </Button>
                </Col>
                <Col className="button_container mac">
                  <Button
                    color="secondary download mac"
                    data-game="Jigsaw Puzzle"
                    data-platform="Mac"
                    tag={LinkComponent}
                    to="https://itunes.apple.com/us/app/id1436430887?ls=1&mt=12"
                    rel="nofollow"
                  >
                    Download for Mac™
                  </Button>
                </Col>
                <Col className="button_container windows">
                  <Button
                    color="secondary download windows"
                    data-game="Jigsaw Puzzle"
                    data-platform="Windows"
                    tag={LinkComponent}
                    to="https://www.microsoft.com/store/apps/9p33r1js35qp"
                    rel="nofollow"

                  >
                    Download for Windows™
                  </Button>
                </Col>
                <Col className="button_container linux">
                  <Button
                    color="secondary download linux"
                    data-game="Jigsaw Puzzle"
                    data-platform="Linux"
                  >
                    Download for Linux™
                  </Button>
                </Col>
                <Col className="button_container android">
                  <Button
                    color="secondary download android"
                    data-game="Jigsaw Puzzle"
                    data-platform="Android"
                  >
                    Download for Android
                  </Button>
                </Col>
                <Col className="button_container ios">
                  <Button
                    color="secondary download ios"
                    data-game="Jigsaw Puzzle"
                    data-platform="iOS"
                  >
                    Download for iOS
                  </Button>
                </Col>
                <Col>
                  <div className="image_container">
                    <div className="image_border" />
                    <img
                      className="lazyload"
                      width="990"
                      height="630"
                      alt="Jigsaw Puzzle game"
                      data-src={assetPath("frontpage_desktop", "jpg")}
                    />
                  </div>
                </Col>
              </div>
            </Col>
          </Row>
        </Container>

        <Container id="contact">
          <Row>
            <Col>
              <div>
                <h2>Contact: Please give us questions and feedback</h2>
              </div>
              <div>
                <p className="text_section">
                  We're always looking to improve the game, so if you have any questions, ideas or feedback, please let us know at{" "}
                  <a href="#" onClick={mailTo}>
                    contact@online-jigsaw-puzzles.com
                  </a>. We’re always glad to hear from you!.
                  <br />
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container id="footer">
          <FooterComponent />
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(AboutComponent);



// WEBPACK FOOTER //
// ./src/routes/collections/components/AboutComponent/index.js